{
  "app": {
    "title": "Burgerbegroting 2027"
  },
  "rrn": {
    "page_title": "Bepaal mee welke ideeën dit jaar financiële steun krijgen",
    "page_description": "Van 3 tot en met 25 september kun je hier stemmen op jouw favoriete ideeën.",
    "itsme_label": "Via ITSME",
    "button": "Inloggen met itsme®",
    "divider": "of",
    "submit": "START",
    "input": {
      "label": "Login met je rijksregisternummer",
      "placeholder": "xx.xx.xx-xxx.xx"
    },
    "errors": {
      "general": "Het is momenteel niet mogelijk om te stemmen.",
      "not_allowed": "Je woont niet in district Antwerpen."
    },
    "resume": {
      "title": "Welkom terug!",
      "detail": "Hervat de sessie om verder te gaan waar je vorige keer gebleven was of bekijk de ideeën die je vorige keer zag opnieuw.",
      "continue": "Sessie hervatten",
      "restart": "Mijn eerdere selectie herbekijken"
    },
    "privacy": "Privacyverklaring"
  },
  "footer": {
    "stad_antwerpen_alt": "Stad Antwerpen",
    "tree_company_alt": "Tree Company"
  },
  "swipe": {
    "intro": {
      "title": "Aan de slag!",
      "instructions": "Swipe om op ideeën te stemmen: veeg naar links wat je niet belangrijk vindt, naar rechts waar je wél op wil stemmen. Je mag op zoveel ideeën stemmen als je wil.",
      "cta": "Swipe dit kaartje naar links of rechts om te starten."
    },
    "accept": "Stem voor",
    "reject": "Geen stem",
    "previous": "Vorig idee",
    "next": "Volgend idee",
    "my_choice": "Mijn keuze",
    "counter": "Aantal gekozen ideeën",
    "to_overview": "Naar overzicht"
  },
  "results": {
    "back": "Vorige",
    "title": "Bedankt voor je stem!",
    "description_1": "Je stem werd opgeslagen. Hieronder zie je welke ideeën jij gekozen hebt.",
    "description_2": "Je kunt je stem hieronder nog aanpassen of via de ‘Vorige’ knop terug door de ideeën bladeren en extra ideeën selecteren. Daarna mag je dit venster afsluiten.",
    "discover": "Schrijf je in voor de nieuwsbrief",
    "more_info": "Meer info",
    "remove": "Verwijder",
    "empty_title": "Bedankt voor je deelname!",
    "empty_description_1_start": "Je hebt geen ideeën geselecteerd.",
    "empty_description_1_link": "Klik hier",
    "empty_description_1_end": "als je graag de stemming herstart.",
    "empty_description_2": "Als je geen ideeën wil selecteren mag je dit venster afsluiten, of je kunt je via de knop hieronder inschrijven voor onze nieuwsbrief om verder op de hoogte te blijven.",
    "districtsbreed": "Districtsbreed",
    "confirm_remove": {
      "title": "Weet je zeker dat je dit idee wil verwijderen uit je selectie?",
      "confirm": "Verwijderen",
      "cancel": "Annuleren"
    },
    "toast": {
      "removed": {
        "title": "Idee verwijderd",
        "message": "De aanpassing werd goed geregistreerd."
      }
    },
    "discover_url": "https://confirmsubscription.com/h/j/1593DC742B46B4F5",
    "final_vote_start": "Schrijf je in voor onze nieuwsbrief en kom voor extra stemkracht op 27/9 live stemmen op de",
    "final_vote_link": "Live Ideeënfinale!",
    "final_vote_url": "https://burgerbegroting.be/nl/info-live-ideeenfinale"
  },
  "ranking": {
    "not_voted_yet": "Er werden nog geen stemmen uitgebracht",
    "vote": "{{count}} stem",
    "votes": "{{count}} stemmen"
  }
}
